import { UseMutateAsyncFunction } from '@tanstack/react-query';
import { IDocument, ITrainingSet } from '../../../types/my-types';
import removeTrailingSpaces from './removeTrailingSpaces';
import { useNavigate } from 'react-router';

export interface IInput {
  documents: string[];
  label: string;
  training_set?: string;
  glynt_tags?: string[];
  is_experimental?: boolean;
}
export async function finishUpload(
  isExtraction: boolean,
  createExtractionBatch: any,
  dataPoolId: string,
  acceptedDocs: any,
  trainingSet: ITrainingSet | undefined,
  label: string,
  setToast: (value: any) => void,
  isUpdate: boolean | undefined,
  updateTrainingSet: any,
  createTrainingSet: any,
  generatePages: UseMutateAsyncFunction<void, unknown, { id: string; extraction: boolean }>,
  history: any,
  cache: any,
  isExperimental?: boolean
) {
  // const navigate = useNavigate();

  if (isExtraction) {
    let input: IInput = {
      documents: acceptedDocs.map((e: IDocument) => e.id),
      label,
    };

    input.training_set = trainingSet!.id;

    try {
      const data = await createExtractionBatch({
        documents: input.documents,
        label: removeTrailingSpaces(input.label),
        training_set: input.training_set,
        is_experimental: isExperimental,
      });
      cache.invalidateQueries({ queryKey: ['extractionBatches'] });
      await generatePages({ id: data.id, extraction: true });
    } catch (error: any) {
      setToast({
        open: true,
        variant: 'error',
        message:
          error.message ||
          'Sorry, failed to create extraction batch. Please contact Glynt representative',
      });
    }
  } else if (isUpdate) {
    const newDocuments = trainingSet!.documents.concat(acceptedDocs.map((e: IDocument) => e.id));
    try {
      await updateTrainingSet({
        id: trainingSet!.id,
        data: {
          documents: newDocuments,
        },
      });
      // TODO: Refactor document list on manage page
      cache.invalidateQueries({ queryKey: ['trainingSet'] });
      cache.invalidateQueries({ queryKey: ['documents'] });
      await generatePages({ id: trainingSet!.id, extraction: false });

      // window.location.reload();
    } catch (error: any) {
      setToast({
        open: true,
        variant: 'error',
        message:
          error.message || 'Sorry, failed to add documents. Please contact Glynt representative',
      });
    }
  } else {
    if (acceptedDocs.length > 0) {
      const newDocuments = acceptedDocs.map((e: IDocument) => e.id);

      try {
        const data = await createTrainingSet({
          label: label,
          documents: newDocuments,
        });
        cache.invalidateQueries({ queryKey: ['trainingSets'] });
        await generatePages({ id: data.id, extraction: false });
        return {
          returnedId: data.id,
          returnedType: 'trainingSet',
        };
        // navigate(`/data-pools/${dataPoolId}/train/${data.id}`);
      } catch (error) {
        console.error('error creating training set: ', error);
      }
    }
  }
}
